export default __webpack_public_path__ + "static/media/campminderIcon.3d4b6bb8.png";